/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/card/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";
import useUserAccess from "../../../effects/useUserAccess";
import { get } from "lodash";

interface Props {
  cardData?: Data[] | null;
}

interface RowData {
  id: string;
  name: string;
}

const mapDataToTable = (card: Data[]): RowData[] => {
  return card.map((data: Data) => {
    return {
      id: data.id as string,
      name: data.attributes.Name,
    };
  });
};

export default function CardTable({ cardData }: Props) {
  const history = useHistory();
  const access = useUserAccess();
  const data = mapDataToTable(cardData);
  const editAction = (rowData: RowData) => {
    history.push(`/card/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/card/view/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Card"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
